import React from 'react'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { FileDown } from 'lucide-react'

export default function ExcelButton({ handleDownloadExcel, loadingExcel }) {
	const { t } = useTranslation()
	return (
		<Button
			type="primary"
			className="h-8 bg-blue-600 hover:bg-blue-400 disabled:bg-gray-100"
			onClick={handleDownloadExcel}
			loading={loadingExcel}
		>
			<div className="flex items-center gap-2">
				<FileDown size={18} />
				{t('exportExcelFile')}
			</div>
		</Button>
	)
}
